import { render, staticRenderFns } from "./ItemListCopyBtn.vue?vue&type=template&id=636bf53a&"
import script from "./ItemListCopyBtn.vue?vue&type=script&lang=js&"
export * from "./ItemListCopyBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports